import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import preLoaderActions from 'actions/preLoaderActions';
import identityValidationActions from 'actions/identityValidationActions';
import stepsActions from 'actions/stepsActions';
import mapActions from 'actions/mapActions';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { IdentityVerification } from './IdentityVerification';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        immStepsState: state.steps,
        products: state.products,
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(stepsActions, dispatch),
    mapActions: bindActionCreators(mapActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    identityValidationActions: bindActionCreators(identityValidationActions, dispatch),
});

export const IdentityVerificationView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withFeatureToggling(IdentityVerification));
